import React from "react";
import CommonDiv1 from "../../../../shared/CommonDiv1";
import IMAGES from "../../../../Images";
import TextButtonContainer from "../../../../shared/TextButtonContainer";
import GridResPonsiveCards from "../../../../technologies/ml-assistant/components/GridResPonsiveCards";
import ThreeCards from "../../../../shared/ThreeCards";
import Globe from "../../../../sms/components/Globe";
import WhatsappDiv6 from "../../../../shared/WhatsappDiv6";
import { HeroContainer } from "../../../../assets/styles/theme/styles";
import TabSectionCommon from "../../../../shared/TabSectionCommon";
import { Helmet } from "react-helmet";

export default function Much() {
  const cards = [
    {
      body: [
        `Improve remotely based user-experience as their areas may have cellular network Issues, but with the help of data network based channels can be initiated to the mobile numbers.`,
      ],
    },
    {
      body: [
        `Priorities can be defined based on certain use-cases of clients and it can be modified using user-Interface at any given point of time.`,
      ],
    },
    {
      body: [
        `Augment the reach ability towards OTP deliveries with expanded options for users to get the OTPs in multiple modes.`,
      ],
    },
    {
      body: [
        `Gives multiple channel options to submit the OTP. Enhance the security level.`,
      ],
    },
  ];

  const text = [
    "Texts are widely available on mobile devices and are ready to be sent all over the world!",
    "For sign-up, login, or transaction approvals, keep things easy with a one-time SMS passcode.",
  ];

  const helpItems = [
    {
      title: "SMS",
      description: `Choose your pricing that fits your need, credit your account as
      pay you go model or get the volume discount on large quantity of SMS purchase.
      `,
      image: `${IMAGES.muchc1sms}`,
    },
    {
      title: "WhatsApp",
      description: `Engage your consumers on world’s most popular messaging app use whatsApp for better conversions with loaded features.
      `,
      image: `${IMAGES.muchc2whatsapp}`,
    },
    {
      title: "Voice",
      description: `Reach out globally and improve user experience by conducting voice interactions in your consumers’ native language.
      `,
      image: `${IMAGES.muchc3voice}`,
    },
    {
      title: "RCS",
      description: `RCS Business Messaging is the next generation of SMS, delivering rich functionality of a mobile app in messages.
      `,
      image: `${IMAGES.muchc4rcs}`,
    },
    {
      title: "Email",
      description: `Send Email with reliable inbox delivery.
      `,
      image: `${IMAGES.muchc5email}`,
    },
  ];

  const data = [
    "Keep control verification requests, status updates, and notifications with our REST API and reduce development and maintenance time with our SDK for Android, iOS, or JavaScript.",
  ];

  const codeSnippets = [
    {
      language: "Onboarding",
      contentHead: "Remove risk and friction from the onboarding process",
      contentPara: `Detect bad actors, prevent artificial and fake creation, and boost conversion rates by engaging users over the cost-effective channels.`,
    },
    {
      language: "Sign in",
      contentHead:
        "Allow only legitimate users in while adding security in the background",
      contentPara: `Spot and stop bots and account takeover attempts with our anti-fraud solutions. Prove number possession over the most cost-effective channel at sign-in.`,
    },
    {
      language: "Transaction",
      contentHead: "Authenticate and protect users in all transactions",
      contentPara: `Ensure users are who they claim to be with our wide selection of authentication and anti-fraud solutions. Strengthen security around any important user transactions, before sharing any sensitive information with users.`,
    },
    {
      language: "Account Update",
      contentHead:
        "Help your users update and recover their accounts quickly and securely",
      contentPara: `Prevent account takeovers and ensure phone number possession using multi-factor authentication solutions, and help users stay up-to-date with PII data, account data, and password resets.`,
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Optimize Connections with Interactive Voice Response Solutions
        </title>
        <meta
          name="description"
          content="Tubelight's Interactive Voice Response services redefine communication efficiency, offering a seamless and interactive experience for customer engagement."
        />
        <meta
          name="keywords"
          content="interactive voice response services
          "
        ></meta>
      </Helmet>
      <HeroContainer imageUrl={IMAGES.smsbgdiv1} ht="1200px" bgSize="cover">
        <CommonDiv1
          title={"Omni Channel optimized Authentication"}
          description={`Tubelight Communications helps you
          authenticate your customers on channel of their choice and method of their
          choice.
          `}
          fgvideo={IMAGES.muchfg1video}
          fgimage={IMAGES.muchfg1}
          btns={["Try for Free", "Talk to Expert"]}
          video
        />
        <ThreeCards
          title="No-hassle authentication on any channel, anywhere."
          subtitle="SMS Authentication"
          description="End-users never need to share or show a pin code in the verification process, so there’s no room for social engineering.        "
          // btn={"Learn more"}
          helpItems={helpItems}
          cols={5}
        />
      </HeroContainer>

      <HeroContainer imageUrl={IMAGES.bg4}>
        <GridResPonsiveCards heading={`Features`} cards={cards} />
      </HeroContainer>

      <HeroContainer imageUrl={IMAGES.bg2}>
        <TabSectionCommon heading={`Usecases`} codeSnippets={codeSnippets} />
        <WhatsappDiv6
          heading={"Easy, flexible integration with our REST API and SDK"}
          data={data}
        />
      </HeroContainer>
    </>
  );
}
